import raiseNotification from "../utils/raiseNotification";
import dispatchAddNewsletter from "../transport/newsletter";

function subscriptionSuccess(subscriptionInput) {
    return (data) => {
        subscriptionInput.value = "";
        raiseNotification(data.message, "success");
    };
}

function subscriptionFailed(response) {
    let { error } = response;
    if (!error || response.status === 429) {
        error = "Invalid email";
    }
    raiseNotification(error, "error");
}

export default function subscriptionForm(context, subscriptionForm) {
    const settings = context.settings;
    const siteId = settings.site.id;
    const subscriptionInput = subscriptionForm.querySelector(".newsletter-element__input");
    const subscriptionSubmit = subscriptionForm.querySelector(".newsletter-element__submit");

    function handleSubscription(subscriptionInput) {
        if (subscriptionInput.value) {
            dispatchAddNewsletter(siteId, subscriptionInput.value)
                .then(subscriptionSuccess(subscriptionInput))
                .catch(subscriptionFailed);
        } else {
            raiseNotification("Please enter your email", "error");
        }
    }

    subscriptionInput.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleSubscription(subscriptionInput);
        }
    });

    subscriptionSubmit.addEventListener("click", () => {
        handleSubscription(subscriptionInput);
    });
}
